import { Row, Col } from "react-bootstrap";
import logoIosfa from "../assets/images/logo_iosfa.png";

export default function Header() {
  return (
    <header className="container-fluid">
      <Row>
        <Col md={8} sm={9} xs={12} className="app">
          <Row className="d-flex align-items-center px-3">
            <div className="d-flex align-items-center">
              <a href="./">
                <img className="app-logo" src={logoIosfa} alt="IOSFA" />
              </a>
              <span className="app-titulo br-izq-2px gris ml-2">GRILLA</span>
            </div>
          </Row>
        </Col>
        <Col md={4} sm={3} className="app-descripcion centro-vertical text-right">
           CONSULTA DE FUNCIONARIO/AS, {/*ORGÁNICA,*/} ORGANIGRAMA Y ESTABLECIMIENTOS 
        </Col>
      </Row>
    </header>
  );
}
